import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import AdminProductDetail from "./views/admin/product/Detail.vue";
import AdminProduct from "./views/admin/product/Index.vue";
import AdminDiscountDetail from "./views/admin/discount/Detail.vue";
import AdminDiscount from "./views/admin/discount/Index.vue";
import MpProductDetail from "./views/mpProduct/Detail.vue";
import MpProduct from "./views/mpProduct/Index.vue";
import CostTable from "./views/costTable/Index.vue";
import KarHesabi from "./views/karHesabi/Index.vue";
import DispatchTime from "./views/dispatchTime/Index.vue";
import MpDiscountDetail from "./views/mpDiscount/Detail.vue";
import MpDiscount from "./views/mpDiscount/Index.vue";
import StockGroupDetail from "./views/stockGroup/Detail.vue";
import StockGroup from "./views/stockGroup/Index.vue";
import InsuranceDetail from "./views/insurance/Detail.vue";
import Insurance from "./views/insurance/Index.vue";
import Discount from "./views/discount/Index.vue";
import DiscountDetail from "./views/discount/Detail.vue";
import PriceIncrease from "./views/PriceIncrease/Index.vue";
import PriceIncreaseDetail from "./views/PriceIncrease/Detail.vue";
import Order from "./views/order/Index.vue";
import ReturnedOrders from "./views/returnedOrders/Index.vue";
import PendingShipments from "./views/pendingShipments/Index.vue";
import Stock from "./views/stock/Index.vue";
import BarcodePrint from "./views/order/BarcodePrint.vue";
import BarcodePrintOld from "./views/order/BarcodePrintOld.vue";
import JewelryCertificatePrint from "./views/print/JewelryCertificatePrint.vue";
import InventoryBarcodePrint from "./views/print/InventoryBarcodePrint.vue";
import FormulaMultiplier from "./views/formulaMultiplier/Index.vue";
import FormulaMultiplierDetail from "./views/formulaMultiplier/Detail.vue";
import Payment from "./views/payment/Index.vue";
import InvoicePrint from "./views/order/InvoicePrint.vue";
import LoginPage from "./views/account/LoginPage.vue";
import Users from "./views/account/Users.vue";
import Setting from "./views/setting/Index.vue";
import PoolFormula from "./views/poolFormula/Index.vue";
import Report from "./views/report/Index.vue";
import PoolFormulaDetail from "./views/poolFormula/Detail.vue";
import PoolOrder from "./views/poolOrder/Index.vue";
import AdminDashboard from "./views/admin/Dashboard.vue";
import AdminUsers from "./views/admin/Users.vue";
import AdminUserTenants from "./views/admin/UserTenants.vue";
import AdminCategories from "./views/admin/category/Index.vue";
import AdminCarousels from "./views/admin/carousel/Index.vue";
import AdminBestSellers from "./views/admin/bestseller/Index.vue";
import AdminPartnerBanks from './views/admin/partnerBank/Index.vue';
import AdminPartnerBankDetail from './views/admin/partnerBank/Detail.vue';
import AdminCompanies from './views/admin/company/Index.vue';
import AdminCompanyDetail from './views/admin/company/Detail.vue';
import AdminMpCompanies from './views/admin/mpCompany/Index.vue';
import AdminMpCompanyDetail from './views/admin/mpCompany/Detail.vue';
import RichOrder from './views/richOrder/Index.vue';
import AdminCampaignCommissions from './views/admin/campaignCommission/Index.vue';
import AdminInvoiceLabor from './views/admin/invoiceLabor/Index.vue';
import AdminInvoiceLaborHeld from './views/admin/invoiceLabor/Held.vue';
import AdminExpectedPayments from './views/admin/expectedPayment/Index.vue';
import Reconciliation from './views/reconciliation/Index.vue';
import ReconciliationDetail from './views/reconciliation/Detail.vue';
import AdminAppSettings from './views/admin/appSettings/Index.vue';
import AdminVariants from './views/admin/variants/Index.vue';
import PartnerBanks from './views/partnerBank/Index.vue';
import CashBanks from './views/cashBank/Index.vue';
import ModernDashboard from './views/ModernDashboard.vue';
import AdminInventory from './views/admin/inventory/Index.vue';
import AdminDeliveryCities from './views/admin/deliveryCity/Index.vue';
import AdminBankHolidays from './views/admin/bankHoliday/Index.vue';
import AdminMarketplacePaymentRules from './views/admin/marketplacePaymentRule/Index.vue';
import MintAgreements from './views/mintAgreement/Index.vue';
import AdminRefineries from './views/admin/refinery/Index.vue';
import AdminCurrencies from './views/admin/currency/Index.vue';
import AdminCashAccounts from './views/admin/cashAccount/Index.vue';
import AdminAtolye from './views/admin/atolye/Index.vue';
import AdminJewelryList from './views/admin/inventory/JewelryList.vue';
import AdminZimmet from './views/admin/inventory/Zimmet.vue';
import AdminKasa from './views/admin/inventory/Kasa.vue';
import AdminOtherItems from './views/admin/inventory/OtherItems.vue';
import AdminInventoryDefinitions from './views/admin/inventory/Definitions.vue';
import AdminBorc from './views/admin/inventory/Borc.vue';
import AdminOtherSales from './views/admin/inventory/OtherSales.vue';
import Kasam from './views/Kasam.vue';
import KritikStok from './views/KritikStok.vue';
import AdminCriticalStock from './views/admin/criticalStock/Index.vue';
import AdminReconciliationHistory from './views/admin/reconciliationHistory/Index.vue';
import Leaves from './views/leaves/Index.vue';
import AdminLeaves from './views/admin/leaves/Index.vue';
import YurticiKargoTest from './views/yurticiKargoTest/Index.vue';
import CargoListPage from './views/yurticiKargo/CargoListPage.vue';
import CargoCostSettlement from './views/yurticiKargo/CargoCostSettlement.vue';
import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";

const adminWebAllowedPaths = [
  '/admin/product',
  '/admin/categories',
  '/admin/carousels',
  '/admin/bestsellers',
  '/admin/variants'
];
import store from "./store";

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/modern-dashboard',
      name: 'modern-dashboard',
      component: ModernDashboard,
    },
    {
      path: '/poolorder',
      name: 'poolindex',
      component: PoolOrder,
    },
    {
      path: '/poolformula',
      name: 'formulaindex',
      component: PoolFormula,
    },
    {
      path: '/poolformula/detail/:id',
      name: 'formula-detail',
      component: PoolFormulaDetail,
    },
    {
      path: '/poolformula/detail',
      name: 'formuladetail2',
      component: PoolFormulaDetail,
    },
    {
      path: '/setting',
      name: 'setting',
      component: Setting,
    },
    {
      path: '/order/barcodeprint',
      name: 'barcodeprint',
      component: BarcodePrint,
    },
    {
      path: '/order/barcodeprint-old',
      name: 'barcodeprint-old',
      component: BarcodePrintOld,
    },
    {
      path: '/order/invoiceprint',
      name: 'InvoicePrint',
      component: InvoicePrint,
    },
    {
      path: '/print/jewelry-certificate',
      name: 'jewelry-certificate-print',
      component: JewelryCertificatePrint,
      meta: { layout: 'empty-layout' },
    },
    {
      path: '/print/inventory-barcode',
      name: 'inventory-barcode-print',
      component: InventoryBarcodePrint,
      meta: { layout: 'empty-layout' },
    },
    {
      path: '/order',
      name: 'order',
      component: Order, // import('./views/order/index.vue')
    },
    {
      path: '/returned-orders',
      name: 'returned-orders',
      component: ReturnedOrders,
    },
    {
      path: '/pending-shipments',
      name: 'pending-shipments',
      component: PendingShipments,
    },
    {
      path: '/rich-order',
      name: 'rich-order',
      component: RichOrder,
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment, // import('./views/order/index.vue')
    },
    {
      path: '/stock',
      name: 'stock',
      component: Stock, // import('./views/order/index.vue')
    },
    {
      path: '/partner-banks',
      name: 'partner-banks',
      component: PartnerBanks,
    },
    {
      path: '/cash-banks',
      name: 'cash-banks',
      component: CashBanks,
      beforeEnter: (to, from, next) => {
        if (typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.getItem('cashBanksUnlocked') === '1') {
          next();
        } else {
          next('/');
        }
      },
    },

    {
      path: '/mpproduct',
      name: 'mpproduct',
      component: MpProduct,
    },
    {
      path: '/mpproduct/detail',
      name: 'mpproduct-detail2',
      component: MpProductDetail,
    },
    {
      path: '/mpproduct/detail/:id',
      name: 'mpproduct-detail',
      component: MpProductDetail,
    },
    {
      path: '/cost-table',
      name: 'cost-table',
      component: CostTable,
    },
    {
      path: '/kar-hesabi',
      name: 'kar-hesabi',
      component: KarHesabi,
    },
    {
      path: '/dispatch-time',
      name: 'dispatch-time',
      component: DispatchTime,
    },
    {
      path: '/mpdiscount',
      name: 'mpdiscount',
      component: MpDiscount,
    },
    {
      path: '/mpdiscount/detail',
      name: 'mpdiscount-detail2',
      component: MpDiscountDetail,
    },
    {
      path: '/mpdiscount/detail/:id',
      name: 'mpdiscount-detail',
      component: MpDiscountDetail,
    },
    {
      path: '/stockGroup',
      name: 'stockGroup',
      component: StockGroup,
    },
    {
      path: '/stockGroup/detail',
      name: 'stockGroup-detail2',
      component: StockGroupDetail,
    },
    {
      path: '/stockGroup/detail/:id',
      name: 'stockGroup-detail',
      component: StockGroupDetail,
    },
    {
      path: '/insurance',
      name: 'insurance',
      component: Insurance,
    },
    {
      path: '/insurance/detail',
      name: 'insurance-detail2',
      component: InsuranceDetail,
    },
    {
      path: '/insurance/detail/:id',
      name: 'insurance-detail',
      component: InsuranceDetail,
    },

    {
      path: '/formulaMultiplier/detail',
      name: 'formulaMultiplier-detail2',
      component: FormulaMultiplierDetail,
    },
    {
      path: '/formulaMultiplier/detail/:id',
      name: 'formulaMultiplier-detail',
      component: FormulaMultiplierDetail,
    },
    {
      path: '/formulaMultiplier',
      name: 'formulaMultiplier',
      component: FormulaMultiplier,
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
    },
    // Discount routes moved to admin section
    // {
    //   path: "/discount/detail",
    //   name: "discount-detail2",
    //   component: DiscountDetail,
    // },
    // {
    //   path: "/discount/detail/:id",
    //   name: "discount-detail",
    //   component: DiscountDetail,
    // },
    // {
    //   path: "/discount",
    //   name: "discount",
    //   component: Discount,
    // },

    {
      path: '/priceIncrease',
      name: 'priceIncrease',
      component: PriceIncrease,
    },
    {
      path: '/priceIncrease/detail',
      name: 'priceIncrease-detail2',
      component: PriceIncreaseDetail,
    },
    {
      path: '/priceIncrease/detail/:id',
      name: 'priceIncrease-detail',
      component: PriceIncreaseDetail,
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/admin',
      component: AdminDashboard,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/users',
      component: AdminUsers,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/user-tenants',
      component: AdminUserTenants,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/refineries',
      component: AdminRefineries,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/currencies',
      component: AdminCurrencies,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/cash-accounts',
      component: AdminCashAccounts,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/atolye',
      component: AdminAtolye,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/product',
      component: AdminProduct,
      meta: {
        authorize: [Role.Admin, Role.AdminWeb],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/product/detail',
      component: AdminProductDetail,
      meta: {
        authorize: [Role.Admin, Role.AdminWeb],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/product/detail/:id',
      component: AdminProductDetail,
      meta: {
        authorize: [Role.Admin, Role.AdminWeb],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/discount',
      component: AdminDiscount,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/discount/detail',
      component: AdminDiscountDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/discount/detail/:id',
      name: 'admin-discount-detail',
      component: AdminDiscountDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/categories',
      name: 'admin-categories',
      component: AdminCategories,
      meta: {
        authorize: [Role.Admin, Role.AdminWeb],
        layout: 'admin-layout',
      },
    },
    {
      path: "/admin/carousels",
      name: "admin-carousels",
      component: AdminCarousels,
      meta: {
        authorize: [Role.Admin, Role.AdminWeb],
        layout: "admin-layout"
      }
    },
    {
      path: "/admin/bestsellers",
      name: "admin-bestsellers",
      component: AdminBestSellers,
      meta: {
        authorize: [Role.Admin, Role.AdminWeb],
        layout: "admin-layout"
      }
    },
    {
      path: '/admin/partner-banks',
      name: 'admin-partner-banks',
      component: AdminPartnerBanks,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/delivery-cities',
      name: 'admin-delivery-cities',
      component: AdminDeliveryCities,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/bank-holidays',
      name: 'admin-bank-holidays',
      component: AdminBankHolidays,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/marketplace-payment-rules',
      name: 'admin-marketplace-payment-rules',
      component: AdminMarketplacePaymentRules,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/mint-agreements',
      name: 'mint-agreements',
      component: MintAgreements,
    },
    {
      path: '/admin/partner-bank/detail',
      name: 'admin-partner-bank-detail-new',
      component: AdminPartnerBankDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/partner-bank/detail/:id',
      name: 'admin-partner-bank-detail',
      component: AdminPartnerBankDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/companies',
      name: 'admin-companies',
      component: AdminCompanies,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/company/detail',
      name: 'admin-company-detail-new',
      component: AdminCompanyDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/company/detail/:id',
      name: 'admin-company-detail',
      component: AdminCompanyDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/mp-companies',
      name: 'admin-mp-companies',
      component: AdminMpCompanies,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/mp-company/detail',
      name: 'admin-mp-company-detail-new',
      component: AdminMpCompanyDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/mp-company/detail/:id',
      name: 'admin-mp-company-detail',
      component: AdminMpCompanyDetail,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/campaign-commissions',
      name: 'admin-campaign-commissions',
      component: AdminCampaignCommissions,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/invoice-labor',
      name: 'admin-invoice-labor',
      component: AdminInvoiceLabor,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/invoice-labor/held',
      name: 'admin-invoice-labor-held',
      component: AdminInvoiceLaborHeld,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/app-settings',
      name: 'admin-app-settings',
      component: AdminAppSettings,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/variants',
      name: 'admin-variants',
      component: AdminVariants,
      meta: {
        authorize: [Role.Admin, Role.AdminWeb],
        layout: 'admin-layout',
      },
    },
{
      path: '/admin/variants',
      name: 'admin-variants',
      component: AdminVariants,
      meta: {
        authorize: [Role.Admin, Role.AdminWeb],
        layout: 'admin-layout',
      },
    },
 {
      path: '/admin/expected-payments',
      name: 'admin-expected-payments',
      component: AdminExpectedPayments,
      meta: {
        authorize: [Role.Admin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/inventory',
      name: 'admin-inventory',
      component: AdminInventory,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/inventory/jewelry',
      name: 'admin-jewelry-list',
      component: AdminJewelryList,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/inventory/zimmet',
      name: 'admin-zimmet',
      component: AdminZimmet,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/inventory/kasa',
      name: 'admin-kasa',
      component: AdminKasa,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/inventory/other-items',
      name: 'admin-other-items',
      component: AdminOtherItems,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/inventory/definitions',
      name: 'admin-inventory-definitions',
      component: AdminInventoryDefinitions,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/inventory/borc',
      name: 'admin-inventory-borc',
      component: AdminBorc,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/inventory/other-sales',
      name: 'admin-inventory-other-sales',
      component: AdminOtherSales,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/kasam',
      name: 'kasam',
      component: Kasam,
    },
    {
      path: '/kritik-stok',
      name: 'kritik-stok',
      component: KritikStok,
    },
    {
      path: '/admin/mutabakat-gecmisi',
      name: 'admin-reconciliation-history',
      component: AdminReconciliationHistory,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/admin/inventory/kritik-stok',
      name: 'admin-critical-stock',
      component: AdminCriticalStock,
      meta: {
        authorize: [Role.Admin, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {
      path: '/leaves',
      name: 'leaves',
      component: Leaves,
    },
    {
      path: '/admin/leaves',
      name: 'admin-leaves',
      component: AdminLeaves,
      meta: {
        authorize: [Role.Admin, Role.AdminWeb, Role.EnvanterAdmin],
        layout: 'admin-layout',
      },
    },
    {





      path: '/reconciliation',
      name: 'reconciliation',
      component: Reconciliation,
    },
    {
      path: '/reconciliation/detail',
      name: 'reconciliation-detail',
      component: ReconciliationDetail,
    },
    {
      path: "/login",
      component: LoginPage,
    },
    {
      path: '/yk-test',
      name: 'yk-test',
      component: YurticiKargoTest,
      meta: { layout: 'empty-layout', hidden: true },
    },
    {
      path: '/kargo-bilgileri',
      name: 'kargo-bilgileri',
      component: CargoListPage,
    },
    {
      path: '/kargo-maliyet',
      name: 'kargo-maliyet',
      component: CargoCostSettlement,
    },

    // otherwise redirect to home
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  const currentUser = authenticationService.currentUserValue;

  if (to.path !== '/login' && !currentUser) {
    return next({
      path: '/login',
      query: {
        returnUrl: to.path,
      },
    });
  }

  // Envanter Admin: SADECE Envanter Yönetimi ekranları + kendi Kasam'ı + sertifika yazdırma (diğer tüm sayfalar → /admin/inventory)
  if (currentUser && currentUser.isEnvanterAdmin
      && to.path !== '/login' && to.path !== '/kasam' && to.path !== '/kritik-stok'
      && to.path !== '/leaves'
      && !(to.path.startsWith('/admin/leaves') && currentUser.canManageLeaves)
      && !to.path.startsWith('/admin/inventory')
      && !to.path.startsWith('/admin/mutabakat-gecmisi')
      && !to.path.startsWith('/print/jewelry-certificate')) {
    return next({ path: '/admin/inventory' });
  }

  // Admin product sayfalarından çıkıldığında TenantId'yi sıfırla ve listeyi temizle
  if (
    from.path &&
    from.path.startsWith('/admin/product') &&
    !to.path.startsWith('/admin/product')
  ) {
    localStorage.setItem('selectedTenantId', '0');
    localStorage.removeItem('selectedMpId');
    // Store'dan product listesini temizle
    store.dispatch('products/clearProducts');
  }

  if (to.path.startsWith('/admin')) {
    if (!currentUser) {
      return next({
        path: '/login',
        query: {
          returnUrl: to.path,
        },
      });
    }

    if (!currentUser.isAdmin
        && !currentUser.canAccessAdmin
        && !(to.path.startsWith('/admin/inventory') && currentUser.canViewInventory)) {
      return next({ path: '/' });
    }

    if (currentUser.isAdminWeb) {
      const isAllowed = adminWebAllowedPaths.some(path => to.path.startsWith(path))
        || (to.path.startsWith('/admin/leaves') && currentUser.canManageLeaves);
      if (!isAllowed) {
        return next({ path: '/admin/product' });
      }
    }
  }

  if (authorize && to.path !== '/login') {
    if (!currentUser) {
      // not logged in so redirect to login page with the return url
      return next({
        path: '/login',
        query: {
          returnUrl: to.path,
        },
      });
    }

    // check if route is restricted by role
    if (authorize.length && !authorize.includes(currentUser.role)
        && !(to.path.startsWith('/admin') && currentUser.canAccessAdmin)
        && !(to.path.startsWith('/admin/inventory') && currentUser.canViewInventory)) {
      // role not authorised so redirect to home page
      return next({
        path: '/',
      });
    }
  }

  if (to.meta && to.meta.layout) {
    store.commit('SET_LAYOUT', to.meta.layout);
  } else if (to.path !== '/login') {
    store.commit('SET_LAYOUT', 'app-layout');
  }

  next();
});
